import { render, staticRenderFns } from "./MyRadio.vue?vue&type=template&id=17e0d4bc&scoped=true"
import script from "./MyRadio.vue?vue&type=script&lang=js"
export * from "./MyRadio.vue?vue&type=script&lang=js"
import style0 from "./MyRadio.vue?vue&type=style&index=0&id=17e0d4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e0d4bc",
  null
  
)

export default component.exports